import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import NotesRender from './NotesRender'

import BodyText from 'components/Luxkit/Typography/BodyText'

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
`

type Props = {
  notes?: string
}

function SummaryAdditionalNotes({ notes }: Props) {
  if (!notes) return null

  return (
    <Item>
      <BodyText weight="semi-bold" variant="large">
        Additional notes
      </BodyText>
      <NotesRender content={notes} type="compact" fontSize="large" />
    </Item>
  )
}

export default SummaryAdditionalNotes
